import React from "react";
import PageHeader from "../../components/PageHeader";
import NewsCategoryCreateComponent from "../../components/NewsCategory/NewsCategoryCreate";

class NewsCategoryCreate extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="NewsCategory Create"
                            Breadcrumb={[
                                { name: "News Categories", navigate: "/news-categories" },
                                { name: "NewsCategory Create", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <NewsCategoryCreateComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewsCategoryCreate;
